import {
  EnvironmentConfig,
  environmentDefaults,
  featureFlagDefaults,
  oidcEvernorthDefault,
} from '@cigna/chcp/shared/environment-util';

const digitaledgeEpp = 'https://p-chk-evernorth-provider.digitaledge.cigna.com';
const resourceLibraryCdn = 'https://chk.static.evernorth.com/';

export const environment: EnvironmentConfig = {
  ...environmentDefaults('evernorth-provider-web'),
  authMethod: 'auth0',
  oidc: {
    ...oidcEvernorthDefault,
    secureUris: [],
  },
  auth0: {
    audience: digitaledgeEpp,
    clientId: 'JTMHW4Ee7GA2SFCG7ep2egNg6iJmSYla',
    connection: 'providers-prod',
    domain: 'https://p.universal-login.cigna.com',
    scope: 'openid profile email',
    redirect_uri: 'https://chk-provider.evernorth.com',
    secureUris: [digitaledgeEpp, '/pbc', `${resourceLibraryCdn}secure/`],
    impersonationConnection: 'workforce',
    impersonationReturnTo: '/dashboard',
    cookieStorage: true,
  },
  redirect: {
    resourceLibrary: resourceLibraryCdn,
    resourceLibraryDrupal: '',
    crossOrigin: {
      domain: 'https://chk-cignaforhcp.cigna.com',
    },
  },
  api: {
    proxy: {
      headers: {
        accept: '*/*',
        content_type: 'application/json',
      },
    },
    gateways: {
      cdn: '',
      resourceContent: 'https://p-chk-digital-static.digitaledge.cigna.com/',
      secureApi: digitaledgeEpp,
      publicApi: `https://p-chk-public.digitaledge.evernorth.com/public`,
      gsgPublicApi: 'https://p-chk-gsg.digitaledge.cigna.com/public',
      gsgSecureApi: 'https://p-chk-gsg.digitaledge.cigna.com',
      graphql: `${digitaledgeEpp}/apollo-graphql`,
      privateLinkRouter: `https://p-chk-evernorth-provider.digitaledge.cigna.com/pbc/identity/v1/federate/_route`,
      publicLinkRouter: '', // todo: update
    },
    searchIndex: 'prodchk',
    salesDemo: false,
  },
  features: {
    ...featureFlagDefaults,
    nextRelease: false,
    patientEnhPower: false,
    claim360GA: false,
    enablePCM: false,
    hasCBHAmIInNetwork: false,
    cocePathwellPCLM: false,
  },
  launchDarklyClientId: '6627eacd01f25f101d225590',
  disabledRoutes: [],
};
